export const Sites = {
  bxadvisor: "url_bx-advisor-client",
  bxbackoffice: "url_bx-backoffice",
  bxcompliance: "url_bx-compliance",
  bxmiddlexclient: "url_bx-middlex-client",
  bxtraderclient: "url_bx-trader-client",
  bxeasyaccount: "url_bx-easy-account",
  bxdigital: "url_bx-digital",
};
